module.exports = __webpack_public_path__ + "img/email.c27f0e20.svg";